const channels = [
  {
    name: "Home",
    path: "/",
    title: "Hair Growth & Wellness Blog",
    description:
      "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  },
  {
    name: "Health & Wellness",
    path: "/health-and-wellness/",
    title: "Health & Wellness",
    description:
      "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  },
  {
    name: "Biology",
    path: "/biology/",
    title: "Biology",
    description:
      "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  },
  // {
  //   name: "Stories",
  //   path: "/stories/",
  //   title: "Stories",
  //   description:
  //     "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  // },
  {
    name: "Product Education",
    path: "/product-education/",
    title: "Product Education",
    description:
      "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  },
  {
    name: "Tips & Tricks",
    path: "/tips-and-tricks/",
    title: "Tips & Tricks",
    description:
      "Read hair growth articles to learn more about the science of hair growth and better understand what is going on with your hair and scalp health.",
  },
  {
    name: "The Menopause Edit",
    path: "/the-menopause-edit/",
    title: "The Menopause Edit",
    description:
      "With doctor-led education and honest stories from women like you, our limited-edition magazine is reshaping the conversation around menopause",
  },
]
module.exports = channels
